import React, { useMemo } from 'react';
import styles from './UserInfo.module.scss';
import { User } from '../../../state/types';
import { UserAvatar } from '../UserAvatar';

interface Props {
  user?: User;
  /** In case user is not provided, you should provide other props as overrides */
  icon?: React.ReactElement;
  userDisplayName?: string;
  description?: string;
}

function prettifyUserRole(role: string) {
  return role?.replace(/_|-/g, ' ') || 'User';
}

const UserInfo: React.FC<Props> = ({ user, icon, userDisplayName, description }) => {
  let userIcon = useMemo(() => icon || (user && <UserAvatar user={user} avatarSize={'normal'} />), [
    icon,
    user
  ]);
  return (
    <div className={styles.userInfoContainer}>
      {userIcon}
      <div className={styles.nameAndRoleContainer}>
        <span className={styles.displayName}>{userDisplayName || user?.getDisplayName()}</span>
        <span className={styles.userRole}>
          {description || prettifyUserRole(user?.getUserRole())}
        </span>
      </div>
    </div>
  );
};

export default UserInfo;
